<template>
  <div>
    <loader v-show="loading" />
    <div class="form-group">
      <input type="text" class="form-control" placeholder="Ketikkan keyword" v-model="keyword" @keyup="keyUp"
        ref="keyword" />
    </div>
    <div>
      <table class="table table-bordered searchbox">
        <thead>
          <tr>
            <th>Code</th>
            <th>Warranty</th>
            <th>Name</th>
            <th>Stock</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(d, k) in items" :key="k" style="cursor: pointer" @click="select(d)">
            <td>{{ d.code }}</td>
            <td>{{ d.warranty }}</td>
            <td>{{ d.name }}</td>
            <td>{{ d.stock }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Loader from "../../../components/Loader.vue"
import { HTTPAUTH } from "../../../lib/httplib";
export default {
  components: { Loader },
  data () {
    return {
      items: [],
      keyword: "",
      loading: true
    };
  },
  mounted () {
    this.$refs.keyword.focus();
  },
  created () {
    this.load()
  },
  props: ['object'],
  methods: {
    load () {
      this.loading = true
      HTTPAUTH.get(
        "/api/v1/search/product/active?size=5&q=" + this.keyword
      ).then(res => {
        this.items = res.data.data;
        this.loading = false
      }).catch(() => {
        this.loading = false
      });
    },
    keyUp (e) {
      if (e.keyCode == 27) {
        this.object.show = false;
      }
      if (e.keyCode == 13) {
        this.load();
      } else {
        setTimeout(this.load, 1000);
      }
    },
    select (d) {
      this.$emit('onSelect', d);
    }
  }
};
</script>

<style scoped>
.searchbox>tbody>tr:hover {
  background-color: #ebede0;
}
</style>